namespace Gamification.Gamification {
    export interface UtentiProdottiEsperienzeForm {
        IdUtenteProdotto: Serenity.IntegerEditor;
        IdProdottoEsperienza: Serenity.IntegerEditor;
        Valore: Serenity.IntegerEditor;
        Stato: Serenity.BooleanEditor;
    }

    export class UtentiProdottiEsperienzeForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiProdottiEsperienze';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiProdottiEsperienzeForm.init)  {
                UtentiProdottiEsperienzeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(UtentiProdottiEsperienzeForm, [
                    'IdUtenteProdotto', w0,
                    'IdProdottoEsperienza', w0,
                    'Valore', w0,
                    'Stato', w1
                ]);
            }
        }
    }
}
